// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
// import Link from "@insite/mobius/Link"; // Starter Custom Code
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import * as React from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Heading, { HeadingPresentationProps } from "@store/Library/Components/Toolkit/Heading";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { spacingStyles } from "@toolkit/Themes/common/mixins";

export interface CardListHeadingStyles {
    heading?: HeadingPresentationProps;
    link?: LinkPresentationProps;
}

export const cardListHeadingStyles: CardListHeadingStyles = {
    heading: {
        variant: "h4",
        forwardAs: "h2",
        itemOffset: 0.3,
        extendedStyles: {
            title: {
                css: css`
                    ${spacingStyles(null, "0.75em")}
                    padding-bottom: 0.6em;
                    border-bottom: 1px solid ${getColor("common.border")};
                `,
            },
        },
    },
    link: linkGetActionLinkProps(),
};
/* Starter Custom Code - End */

interface OwnProps {
    heading: string;
    viewAllUrl?: string;
    // Starter Custom Code
    hasNoResults?: boolean;
    extendedStyles?: CardListHeadingStyles;
    overridedStyles?: CardListHeadingStyles;
}

type Props = OwnProps & React.HTMLAttributes<HTMLElement>; // Starter Custom Code

const CardListHeading: React.FunctionComponent<Props /* Starter Custom Code */> = ({
    heading,
    viewAllUrl,
    // Starter Custom Code
    hasNoResults,
    extendedStyles,
    overridedStyles,
    children,
    ...htmlAttributes
}) => {
    /* Starter Custom Code - Start */
    const styles = useExpandProps(cardListHeadingStyles, extendedStyles, overridedStyles);

    const headingStyles = React.useMemo(() => {
        if (hasNoResults) {
            return styles.heading;
        }

        return mergeProps<CardListHeadingStyles["heading"]>(styles.heading, {
            extendedStyles: {
                title: {
                    css: css`
                        margin: 0;
                        border-bottom: 0;
                    `,
                },
            },
        });
    }, [styles.heading, hasNoResults]);

    return (
        <Heading title={heading} {...headingStyles} className="card-list-heading" {...htmlAttributes}>
            {children}
            {viewAllUrl && (
                <Link
                    href={viewAllUrl}
                    icon={{ iconProps: { src: ChevronRight } }}
                    {...styles.link}
                    className="view-all-link"
                    data-test-selector="cardListHeadingViewAllLink"
                >
                    {translate("View All")}
                    <VisuallyHidden>{heading}</VisuallyHidden>
                </Link>
            )}
        </Heading>
    );
    /* Starter Custom Code - End */
};

export default CardListHeading;
